import { Title } from 'library/styles/text';
import {
  Container,
  InfoText,
  Info,
  IconContainer,
  Icon,
  IconText,
  Line,
  TextContainer,
} from './styles';

const AboutSupport = ({ version, itemCount, syncVersion }) => {
  return (
    <Container>
      <Title>About & support</Title>
      <TextContainer>
        <InfoText>
          {`App version: ${version}`}
        </InfoText>
        {
          syncVersion ? (
            <InfoText>
              {`Sync version: ${syncVersion}`}
            </InfoText>
          ) : null
        }
        <InfoText>
          {`Number of items: ${itemCount}`}
        </InfoText>
      </TextContainer>
      {/* <Info isDisabled href="#"> */}
      {/*  <IconContainer> */}
      {/*    <Icon className="icon-doc" /> */}
      {/*  </IconContainer> */}
      {/*  <IconText>Generate inventory report</IconText> */}
      {/* </Info> */}
      <Line />
      <Info href="mailto:support@colormylife.com">
        <IconContainer>
          <Icon className="icon-envolope" />
        </IconContainer>
        <IconText>support@colormylife.com</IconText>
      </Info>
      <Line />
      <Info href="https://colormylife.com/privacy/" target="_blank" rel="noreferrer noopener">
        <IconContainer>
          <Icon className="icon-key" />
        </IconContainer>
        <IconText>Privacy policy</IconText>
      </Info>
      <Line />
      <Info href="https://colormylife.com/terms-and-conditions/" target="_blank" rel="noreferrer noopener">
        <IconContainer>
          <Icon className="icon-notes" />
        </IconContainer>
        <IconText>Terms of use</IconText>
      </Info>
      <Line />
      <TextContainer>
        <InfoText>Copyright © 2022 Color My Life, Inc.</InfoText>
        <InfoText>Color My Life ®</InfoText>
      </TextContainer>
    </Container>
  );
};

export default AboutSupport;
